import { render, staticRenderFns } from "./statistics-main-current.vue?vue&type=template&id=4793866a&scoped=true"
import script from "./statistics-main-current.vue?vue&type=script&lang=js"
export * from "./statistics-main-current.vue?vue&type=script&lang=js"
import style0 from "./statistics-main-current.vue?vue&type=style&index=0&id=4793866a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4793866a",
  null
  
)

export default component.exports